import { apiDaInscricao } from "../../../servicos/axios";

export type CancelarAgendamentoPayload = {
  agendamentoId: number;
  justificativa: string;
};

export type ApiAgendamento = {
  id: number;
  dataInicial: string;
  dataFinal?: string;
  status: string;
};

export const cancelarAgendamento = async (
  payload: CancelarAgendamentoPayload
): Promise<ApiAgendamento> => {
  const api = apiDaInscricao();

  const body = {
    agendamentoId: payload.agendamentoId,
    justificativa: (payload.justificativa ?? "").trim(),
  };

  const resp = await api.post("/agendamento/Cancelar", body);
  return resp.data?.agendamento as ApiAgendamento;
};
